export default {
  'Credentials.AddNew': ({ credentials }, outlet, internalStateSetter) => {
    let newCredentials = [...credentials];
    newCredentials.push({ name: '', value: '' });
    outlet({ credentials: newCredentials })
    internalStateSetter({ credentials: newCredentials });
  },
  'Credentials.ContentWrapper.Name': ({ credentials, credential, credentialIndex, value }, outlet, internalStateSetter) => {
    let newCredentials = [...credentials];
    newCredentials[credentialIndex] = { ...credential, name: value };
    debounce(function () {
     outlet({ credentials: newCredentials })
    }, 1500);
    internalStateSetter({ credentials: newCredentials });
  },
  'Credentials.ContentWrapper.Value': ({ credentials, credential, credentialIndex, value }, outlet, internalStateSetter) => {
    let newCredentials = [...credentials];
    newCredentials[credentialIndex] = { ...credential, value: value };
    debounce(function () {
      outlet({ credentials: newCredentials })
    }, 1500);
    internalStateSetter({ credentials: newCredentials});
  },
  'Credentials.ContentWrapper.Delete': ({ credentials, credentialIndex, value }, outlet, internalStateSetter) => {
    let newCredentials = [...credentials];
    newCredentials.splice(credentialIndex, 1);
    outlet({ credentials: newCredentials })
    internalStateSetter({ credentials: newCredentials});
  },
}
let timer;
const debounce = function (fn, d) {
  if (timer) {
    clearTimeout(timer);
  }

  timer = setTimeout(fn, d);
}